import { any, async, fromJSX, nothing, stateful } from "widgets-for-react";
import { initialActivitySelectionBlockState } from "./ActivitySelectionBlock.state";
import { ActivitySelectionBlockLayout } from "./ActivitySelectionBlock.layout";
export const ActivitySelectionBlockWidget = (props)=>{
    return stateful()((s0)=>any({
            key: 'ActivitySelectionBlock'
        })([
            // Render Layout
            fromJSX((setState)=>{
                return ActivitySelectionBlockLayout({
                    ...props,
                    ...s0
                });
            }),
            // Manage async state updates
            async(nothing, {
                key: 'ActivitySelectionLoader'
            })(s0.events).map((resultUpdater)=>(s0)=>{
                    const events = resultUpdater(s0.events);
                    return {
                        ...s0,
                        events
                    };
                })
        ]).map((a)=>a(s0)))(initialActivitySelectionBlockState(props)).run((s0)=>s0);
};
